import { Action, on } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';
import { IndustryPickerState } from "./state";
import * as Actions from './actions';

const initialState =  <IndustryPickerState> {
    expandedIndustryIds: [],
    query: null,
    selectedIndustryIds: []
};

const reducer = createImmerReducer(initialState,
    on(Actions.toggleExpandHeadIndustry, (state, { payload }) => {
        const industryId = payload.industryId;
        const expandedIndustryIds = state.expandedIndustryIds;
        
        if(expandedIndustryIds.some(c => c == industryId)){
            state.expandedIndustryIds = expandedIndustryIds.filter(c => c != industryId);
        }
        else {
            state.expandedIndustryIds.push(industryId);
        }

        return state;
    }),

    on(Actions.selectIndustry, (state, { payload }) => {
        state.selectedIndustryIds = state.selectedIndustryIds.filter(c => c != payload.industryId);
        state.selectedIndustryIds.push(payload.industryId);

        return state;
    }),

    on(Actions.unselectIndustry, (state, { payload }) => {
        state.selectedIndustryIds = state.selectedIndustryIds.filter(c => c != payload.industryId);

        return state;
    }),
    
    on(Actions.filterIndustries, (state, { payload }) => {
        state.query = payload.query;

        return state;
    }),

    on(Actions.resetIndustryFilter, (state, _) => {
        state.query = '';

        return state;
    }),

    on(Actions.loadIndustries, (state, { payload }) => {
        state.selectedIndustryIds = payload.industryIds;

        return state;
    })
);


export function industryPickerReducer(state: IndustryPickerState | undefined, action: Action){
    return reducer(state, action);
}